import { AppRoutingModule } from './app-routing.module';
import { AppComponent } from './app.component';
import {BrowserAnimationsModule} from '@angular/platform-browser/animations';
import { BrowserModule } from '@angular/platform-browser';
import { CoreModule } from "./core/core.module";
import { FontAwesomeModule } from "@fortawesome/angular-fontawesome";
import { ICON_SETTINGS, IconSettingsService } from "@progress/kendo-angular-icons";
import { LoginComponent } from './modules/auth/login/login.component';
import {LogLevel} from './core/logging/log-entry';
import { NgModule } from '@angular/core';
import { SharedModule} from "./shared/shared.module";
import {SmartDeComponent} from "./modules/smart-de/smart-de.component";

@NgModule({
  declarations: [
    AppComponent,
    LoginComponent,
    SmartDeComponent
  ],
  imports: [
    AppRoutingModule,
    BrowserAnimationsModule,
    BrowserModule,
    CoreModule.forRoot(LogLevel.All),
    FontAwesomeModule,
    SharedModule
  ],
  providers: [
    IconSettingsService,
    {
      provide: ICON_SETTINGS,
      useValue: {
        type: "font"
      },
    }
  ],
  bootstrap: [AppComponent]
})
export class AppModule { }
